import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http, settings } from '../../utils/config';

const initialState = {
    img: null,
    isLoadImg: false
}
export const upLoadImgTiktok = createAsyncThunk(
    'TikTok/upLoadImgTiktok',
    async (img) => {
        const shopCipher = settings.getCookie("shop_cipherTikTok");
        const response = await http.post(
            `/upload-imgs-tiktok?shop_cipher=${shopCipher}`,
            { img_data: img }
        );
        return response.data.data.data;
    }
);
const upLoadImg = createSlice({
    name: "upLoadImg",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(upLoadImgTiktok.pending, (state) => {
                state.isLoadImg = true;
            })
            .addCase(upLoadImgTiktok.fulfilled, (state, action) => {
                state.img = action.payload
                state.isLoadImg = false;
            })
            .addCase(upLoadImgTiktok.rejected, (state, action) => {
                state.isLoadImg = false;
            })



    },
});

export default upLoadImg.reducer